
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useAuthState } from "../../../../../../../../Helper/Context";
import { AcknowledgedComplaintGetTableDataAPI } from "../../../../../../../../Redux/EnchrochmentDashboardSlice/ComplaintStatusOfficialsSlice/AcknowledgedComplaintSlice";
import { Loading } from "../../../../../../../../Helper/Loading";
import { HeaderIllegal } from "../../../../IllegalConstructionDashboard/HeaderIllegal";
import EnchrochmentSidebar from "../../../EnchrochmentSidebar/EnchrochmentSidebar";
import { ZoneNameCommanDDL } from "../../../../../../../../Components/IllegalDDL/ZoneNameCommanDDL";
import { WardNameDDL } from "../../../../../../../../Components/IllegalDDL/WardNameDDL";
import { Pegination } from "../../../../../../../../Components/Pegination/Pegination";
import ComplaintDetailsPopUp from "../ClosedComplaintEnchrochmentGrid/Modal/ComplaintDetailsPopUp";
import PathakNamePopUp from "../ClosedComplaintEnchrochmentGrid/Modal/PathakNamePopUp";
import ViewURL from "../Modal/ViewURL";
import TrackPopup from "../../../../IllegalConstructionDashboard/SiteVisit/SiteVisitIllegalGrid/Modal/TrackPopup";
import SizedItemDetailsPopUp from "../ClosedComplaintEnchrochmentGrid/Modal/SizedItemDetailsPopUp";
import ComplaintTrackPopUp from "../ClosedComplaintEnchrochmentGrid/Modal/ComplaintTrackPopUp";

export const ClosedComplaintGrid = () => {

    // add
    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails

    const { t } = useTranslation()

    const [searchParams] = useSearchParams()

    // let YearValue = searchParams.get("YearValue")
    // let MonthValue = searchParams.get("MonthValue")
    // let ZoneValue = searchParams.get("ZoneValue");
    let DashSelect = searchParams.get("DashSelect");
    let Flag = searchParams.get("Flag");
    let ZoneID = searchParams.get("ZoneID")
    let ZoneName = searchParams.get("ZoneName")


    const [IsPost, setIsPost] = useState(false)

    const [IsClear, setIsClear] = useState(false)
    const [IsSearch, setIsSearch] = useState(false)

    const [PerPageCount, setPerPageCount] = useState(10)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(10)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [ImagePopUpData, setImagePopUpData] = useState('')
    const [showImagePopup, setshowImagePopup] = useState(false)

    const [FromDate, setFromDate] = useState('')
    const [ToDate, setToDate] = useState('')
    const [gridData, setgridData] = useState([])
    const [OfficerVisitCloseComplaint, setOfficerVisitCloseComplaint] = useState([])


    // ------------header DDL ------------

    const [YearValue, setYearValue] = useState(sessionStorage.getItem('yearId'))
    const [YearLabel, setYearLabel] = useState(sessionStorage.getItem('yearLable'))
    const [MonthValue, setMonthValue] = useState(sessionStorage.getItem('monthId'))
    const [MonthLabel, setMonthLabel] = useState(sessionStorage.getItem('monthLable'))
    const [ZoneValue, setZoneValue] = useState(sessionStorage.getItem('zoneId'))
    const [ZoneLabel, setZoneLabel] = useState(sessionStorage.getItem('ZoneLable'))

    const [isopen, setIsOpen] = useState(false);
    const toggle = () => {
        setIsOpen(!isopen);
    };

    // ----------------Track PopUp ----------------

    const [TrackPopUpShow, setTrackPopUpShow] = useState(false)

    const handleTrack = () => {
        setTrackPopUpShow(!TrackPopUpShow)
    }

    // handleSizedItemDetails 
    const [SizedItemDetail, setSizedItemDetail] = useState(false)

    const handleSizedItemDetail = (data) => {
        setSizedItemDetail(!SizedItemDetail)
        setgridData(data)
    }

    // ---------------Complaint Track ------------

    const [IsOpenComplaintTrack, setIsOpenComplaintTrack] = useState(false)

    const handleComplaintTrack = (data) => {
        setIsOpenComplaintTrack(!IsOpenComplaintTrack)
        setgridData(data)
    }

    const handleShowImage = (img) => {
        setshowImagePopup(true)
        setImagePopUpData(img)
    }

    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: sessionStorage.getItem('LanguageChange')
    })

    const [ZoneNameID, setZoneNameID] = useState({
        DDL: [],
        ID: ZoneID && ZoneID ? ZoneID : '0',
        Label: ZoneName && ZoneName ? ZoneName : "Select...",
    })

    const [WardNameID, setWardNameID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [ComplaintDetails, setComplaintDetails] = useState(false)
    const [PathakDetails, setPathakDetails] = useState(false)


    const handleComplaintDetails = (data) => {
        setComplaintDetails(!ComplaintDetails)
        setgridData(data)
    }
    const handlePathakDetails = (data) => {
        setPathakDetails(!PathakDetails)
        setgridData(data)
    }

    const handleIsPost = () => {
        setIsPost(!IsPost)
    }
    const handleClear = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsClear(!IsClear)
        setFromDate('')
        setToDate('')
        setZoneNameID({
            ...ZoneNameID,
            ID: 0,
            Label: 'Select...'
        })
        setWardNameID({
            ...WardNameID,
            ID: 0,
            Label: 'Select...'
        })
    }
    useEffect(() => {
        setCurrentPage(0)
        setFrom(1)
        setTo(10)
    }, [ZoneNameID.ID, WardNameID.ID])

    useEffect(() => {
        const data = {
            M_FinacialYearID: YearValue,
            M_MonthID: MonthValue,
            FromDate: FromDate,
            ToDate: ToDate,
            M_ZoneID: ZoneNameID.ID ? ZoneNameID.ID : ZoneValue,
            M_WardID: WardNameID.ID,
            T_ComplaintDetailsID: 0,
            M_WorkTypeID: DashSelect,
            Language: Language.Label,
            M_UserID: UserID,
            FromTop: From,
            ToTop: To,
            token: token,
            Flag: Flag,
            setOfficerVisitCloseComplaint: setOfficerVisitCloseComplaint
        }
        if (Language.Label != null) {
            dispatch(AcknowledgedComplaintGetTableDataAPI({ data }))
        }
    }, [YearValue, MonthValue, DashSelect, From, IsClear, IsSearch, IsPost, Language.Label, FromDate, ToDate, ZoneValue, ZoneNameID.ID, WardNameID.ID])

    const { isLoading, tableData } = useSelector(state => state.AcknowledgedComplaintGetTableData)

    return (
        <>
            {isLoading && <Loading />}
            {/* <div className="container-scroller"> */}
            <HeaderIllegal />
            <div className="wrapper bg-change">
                <EnchrochmentSidebar
                />
                <div className="content1 content mt-1 " style={{}}>

                    <div className="row">
                        <div className="col-12">
                            {/* Closed Complaint */}
                            <h5 className="text-dark fw-bold ps-3 pt-2 all_heading_fontsize">{t('EncroachmentDashboard.ClosedComplaint')}
                             </h5>
                        </div>
                    </div>
                    <div className="row ps-3 py-2 eic_table_styles" >

                        <div class="col-12 col-lg-2 pt-2">
                            <label for="fname" className=" pb-2">{t('EncroachmentDashboard.FromDate')}</label><br />
                            <input
                                className="form-control"
                                id="FromDate"
                                type="date"
                                name="FromDate"
                                value={FromDate}
                                onChange={(e) => setFromDate(e.target.value)}
                            />
                        </div>

                        <div class="col-12 col-lg-2 pt-2">

                            <label for="fname" className=" pb-2">{t('EncroachmentDashboard.ToDate')}</label><br />
                            <input
                                className="form-control"
                                id="ToDate"
                                type="date"
                                name="ToDate"
                                value={ToDate}
                                onChange={(e) => setToDate(e.target.value)}
                                min={FromDate}
                            />
                        </div>


                        <div class="col-12 col-lg-2 pt-2">
                            <ZoneNameCommanDDL
                                ZoneNameID={ZoneNameID}
                                setZoneNameID={setZoneNameID}
                                Flag='Insert'
                                ApiFlag='UserWiseZone'
                                data=''
                                IsPost=''
                                Language={Language}
                                ZoneName={ZoneName}
                                ZoneID={ZoneID}
                            />
                        </div>

                        <div class="col-12 col-lg-2 pt-2">
                            <WardNameDDL
                                WardNameID={WardNameID}
                                setWardNameID={setWardNameID}
                                Flag='Insert'
                                ApiFlag='Master'
                                data=''
                                IsPost=''
                                Language={Language}
                                ZoneNameID={ZoneNameID}
                            />
                        </div>

                        <div className="col-12 col-lg-3 col-md-4 mt-3">

                            {/* <button type="button" className="btn btn-success mx-3">Search</button> */}
                            <button type="button" className="btn btn-danger mt-4" onClick={handleClear}>Clear</button>
                        </div>


                        <div className="row" >
                            <div className="col-12  " >
                                <div className="table-responsive pt-3">
                                    <table className="table table-striped table-bordered">
                                        <thead>
                                            <tr>
                                                <th className="w-6 text-center">{t('EncroachmentDashboard.SrNo')}</th>
                                                {/* <th className="text-center">{t('EncroachmentDashboard.ComplaintUploadDate')}</th> */}
                                                <th className="text-center">{t('EncroachmentDashboard.ComplaintCloseDate')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.ZoneName')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.WardName')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.AreaName')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.UploadComplaintDetails')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.BeforeWorkPhoto')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.AfterWorkPhoto')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.SizedItemDetails')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.Pathak')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.ComplaintActionReport')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.ComplaintTrack')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.VehicleTracking')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.Remark')}</th>
                                            </tr>

                                        </thead>
                                        <tbody>

                                            {
                                                OfficerVisitCloseComplaint && OfficerVisitCloseComplaint?.length > 0 ? OfficerVisitCloseComplaint?.map((i, j) => {
                                                    return (
                                                        <tr>
                                                            <td className="py-1" align="center">{i.rowNum}</td>
                                                            <td className="nowrap" >{i.close_Date ? moment(i.close_Date).format("DD-MM-YYYY") : '-'}</td>
                                                            <td className="nowrap" >{i.zoneName ? i.zoneName : '-'}</td>
                                                            <td >{i.wardName ? i.wardName : '-'}</td>
                                                            <td >{i.m_ZoneWiseArea ? i.m_ZoneWiseArea : '-'}</td>
                                                            <td className="text-center">
                                                                <button className="view_button" onClick={() => {
                                                                    handleComplaintDetails(i)
                                                                }}>
                                                                    {t('EncroachmentDashboard.View')}
                                                                    {/* <i class="fa-regular fa-image"></i> */}
                                                                </button>
                                                            </td>
                                                            {/* <td >{i.uploadDate ? moment(i.uploadDate).format("DD-MM-YYYY") : '-'}</td>
                                                                        <td >{i.createBy_OfficerName ? i.createBy_OfficerName : '-'}</td> */}


                                                            <td className="text-center pt-2">
                                                                {
                                                                    (i.beforeWorkPhoto == null) ?
                                                                        <span>-</span>
                                                                        :
                                                                        <button className="view_button " onClick={() => handleShowImage(i.beforeWorkPhoto)}>
                                                                            {/* {t('EncroachmentDashboard.View')} */}
                                                                            <i class="fa-regular fa-image"></i>
                                                                        </button>
                                                                }

                                                            </td>
                                                            <td className="text-center pt-2">
                                                                {
                                                                    (i.afterWorkPhoto == null) ?
                                                                        <span>-</span>
                                                                        :
                                                                        <button className="view_button " onClick={() => handleShowImage(i.afterWorkPhoto)}>
                                                                            {/* {t('EncroachmentDashboard.View')} */}
                                                                            <i class="fa-regular fa-image"></i>
                                                                        </button>
                                                                }

                                                            </td>
                                                            <td className="text-center">
                                                                <button className="view_button"
                                                                    onClick={() => {
                                                                        handleSizedItemDetail(i)
                                                                    }}
                                                                >
                                                                    {t('EncroachmentDashboard.View')}
                                                                    {/* <i class="fa-regular fa-image"></i> */}
                                                                </button>
                                                            </td>
                                                            <td className="text-center">
                                                                <button className="view_button"
                                                                    onClick={() => {
                                                                        handlePathakDetails(i)
                                                                    }}
                                                                >
                                                                    <td className="nowrap" >{i.pathakName ? i.pathakName : '-'}</td>
                                                                    {/* {t('EncroachmentDashboard.Team')} */}
                                                                    {/* <i class="fa-regular fa-image"></i> */}
                                                                </button>
                                                            </td>
                                                            <td className="text-center">
                                                                <button className="view_button">
                                                                    {/* {t('EncroachmentDashboard.View')} */}
                                                                    <i class="fa-solid fa-file-pdf"></i>
                                                                </button>
                                                            </td>

                                                            <td className="text-center">
                                                                <button className="Track_button" onClick={() => {
                                                                    handleComplaintTrack(i)
                                                                }}>
                                                                    {t('EncroachmentDashboard.Track')}
                                                                </button>
                                                            </td>
                                                            <td className="text-center">
                                                                <button className="Track_button">
                                                                    {t('EncroachmentDashboard.Track')}
                                                                </button>
                                                            </td>

                                                            <td >{i.closeRemarks ? i.closeRemarks : '-'}</td>


                                                        </tr>
                                                    )
                                                })
                                                    :
                                                    <tr>
                                                        <td colSpan={13}>No data found ...</td>
                                                    </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                {OfficerVisitCloseComplaint && OfficerVisitCloseComplaint.length > 0 &&
                                    <Pegination
                                        PerPageCount={PerPageCount}
                                        TotalCount={OfficerVisitCloseComplaint && OfficerVisitCloseComplaint[0].totalCount}
                                        setFrom={setFrom}
                                        setTo={setTo}
                                        CurrentPage={CurrentPage}
                                        setCurrentPage={setCurrentPage}
                                        IsClear={IsClear}
                                    />
                                }
                            </div>


                        </div>
                    </div>
                </div>
            </div>


            {
                ComplaintDetails ?
                    <ComplaintDetailsPopUp
                        // message="Add"
                        handleComplaintDetails={handleComplaintDetails}
                        heading={t('EncroachmentDashboard.ClosedComplaint')}
                        gridData={gridData}
                        isLoading={isLoading}
                    // cancelBtnCallBack={handleAddDepartment}
                    /> : <></>
            }
            {
                PathakDetails ?
                    <PathakNamePopUp
                        // message="Add"
                        handlePathakDetails={handlePathakDetails}
                        heading={t('EncroachmentDashboard.Pathak')}
                        gridData={gridData}
                        DashSelect={DashSelect}
                        YearValue={YearValue}
                        MonthValue={MonthValue}
                        ZoneValue={ZoneValue}
                        Flag='ClosedComplaint'
                        Language={Language}

                    // cancelBtnCallBack={handleAddDepartment}
                    /> : <></>
            }

            {
                showImagePopup ?
                    <ViewURL
                        Heading={t('EncroachmentDashboard.View')}
                        setshowImagePopup={setshowImagePopup}
                        ImagePopUpData={ImagePopUpData}

                    />
                    : ''
            }


            {
                TrackPopUpShow ?
                    <TrackPopup
                        message="Add"
                        handleTrack={handleTrack}
                        heading="Track"
                    // cancelBtnCallBack={handleAddDepartment}
                    /> : <></>
            }
            {
                SizedItemDetail ?
                    <SizedItemDetailsPopUp
                        // message="Add"
                        handleSizedItemDetail={handleSizedItemDetail}
                        heading={t('EncroachmentDashboard.SizedItemDetails')}
                        gridData={gridData}
                        DashSelect={DashSelect}
                        YearValue={YearValue}
                        MonthValue={MonthValue}
                        ZoneValue={ZoneValue}
                        Language={Language}
                        Flag='OwnerDtails'
                    // ApiFlag="APIChange"
                    // cancelBtnCallBack={handleAddDepartment}
                    /> : <></>
            }
            {
                IsOpenComplaintTrack ?
                    <ComplaintTrackPopUp
                        handleComplaintTrack={handleComplaintTrack}
                        gridData={gridData}
                        DashSelect={DashSelect}
                        Language={Language}
                    /> : <></>
            }

        </>
    )
}

